import { useNavigate } from 'react-router-dom';
import { FlaskConical, X } from 'lucide-react';
import { tokenStore } from '@/api/token-store';
import { useAuthStore } from '@/features/auth/store/auth-store';
import { useDemoStore } from '@/shared/store/demo-store';
import { stopDemoWorker } from '@/features/demo/msw/demo-worker';

/**
 * Persistent amber banner shown at the top of the app when in demo mode.
 * Provides a clear exit path back to the landing page.
 */
export function DemoBanner() {
  const navigate = useNavigate();
  const setDemoMode = useDemoStore((s) => s.setDemoMode);

  async function handleExitDemo() {
    // Tear down MSW worker and clear demo auth state
    await stopDemoWorker();
    tokenStore.clear();
    // Update auth store without cross-tab broadcast (demo doesn't affect other tabs)
    useAuthStore.setState({ user: null, isAuthenticated: false });
    setDemoMode(false);
    navigate('/', { replace: true });
  }

  return (
    <div className="sticky top-0 z-50 flex items-center justify-between gap-2 bg-amber-500/15 border-b border-amber-500/30 px-4 py-2 text-sm">
      <div className="flex items-center gap-2 text-amber-200">
        <FlaskConical className="h-4 w-4 text-amber-400 shrink-0" />
        <span>
          <span className="font-semibold text-amber-400">DEMO MODE</span> —{' '}
          <span className="text-amber-200/80">Explore freely. No real trades. No real money.</span>
        </span>
      </div>
      <button
        onClick={handleExitDemo}
        className="flex items-center gap-1.5 rounded-md px-3 py-1 text-xs font-medium text-amber-300 border border-amber-500/40 hover:bg-amber-500/20 transition-colors"
      >
        <X className="h-3 w-3" />
        Exit Demo
      </button>
    </div>
  );
}
